/* ===================================================================
   Upsell Popup - Two-step post-add-to-cart upsell
   =================================================================== */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const root = document.getElementById('upsell-popup-root');

    const productFormEl = document.querySelector('product-form');
    const productForm = (productFormEl && productFormEl.querySelector('form[action*="/cart/add"]'))
                        || document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    const submitBtn = productForm.querySelector('[type="submit"], .product-form__submit');
    if (!submitBtn) return;

    // --- Ingen popup → cart drawer fallback ---
    if (!root) {
      [submitBtn, document.getElementById('floating-buy-button')].filter(Boolean).forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
          if (!productForm.checkValidity()) { productForm.reportValidity(); return; }
          await addMainToCart(productForm, btn, true);
        }, true);
      });
      return;
    }

    // --- Parse data ---
    let step1 = [], step2 = [];
    try { step1 = JSON.parse(root.dataset.step1 || '[]'); } catch(e) {}
    try { step2 = JSON.parse(root.dataset.step2 || '[]'); } catch(e) {}
    const hasStep1 = step1.length > 0;
    const hasStep2 = step2.length > 0;

    buildPopup(root, step1, step2, hasStep1, hasStep2);

    // --- Intercept add to cart ---
    [submitBtn, document.getElementById('floating-buy-button')].filter(Boolean).forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
        if (!productForm.checkValidity()) { productForm.reportValidity(); return; }
        const ok = await addMainToCart(productForm, btn, false);
        if (!ok) return;
        if (hasStep1) showStep(root, 1);
        else if (hasStep2) showStep(root, 2);
        else window.location.href = '/checkout';
      }, true);
    });
  }

  /* -------------------------------------------------------
     Byg popup UI
  ------------------------------------------------------- */
  function buildPopup(root, step1, step2, hasStep1, hasStep2) {

    // Tekster
    setText('#upsell-step1-badge',   root.dataset.step1Badge);
    setText('#upsell-step1-heading', root.dataset.step1Heading);
    setText('#upsell-step1-sub',     root.dataset.step1Sub);
    setText('#upsell-step2-heading', root.dataset.step2Heading);
    setText('#upsell-step2-sub',     root.dataset.step2Sub);

    const nextBtn = document.getElementById('step1-next');
    if (nextBtn) nextBtn.textContent = root.dataset.step1Next || 'Gå videre →';
    const skipBtn = document.getElementById('step2-skip');
    if (skipBtn) skipBtn.textContent = root.dataset.step2Skip || 'Gå videre uden tilkøb →';

    // Step 1 produkter
    const s1Container = document.getElementById('upsell-step1-products');
    if (s1Container && step1.length > 0) {
      if (step1.length === 1) s1Container.classList.add('one-product');
      step1.forEach(p => s1Container.appendChild(buildCard(p, 'Tilkøb')));
    }

    // Step 2 produkter
    const s2Container = document.getElementById('upsell-step2-products');
    if (s2Container && step2.length > 0) {
      step2.forEach(p => s2Container.appendChild(buildCard(p, 'Tilføj til kurv')));
    }

    // Luk ved klik på overlay (udenfor popup-boksen)
    root.querySelectorAll('[data-popup-close]').forEach(el => {
      el.addEventListener('click', () => closePopup(root));
    });

    // Escape tast
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Escape' && root.style.display !== 'none') closePopup(root);
    });

    // Step 1 → Step 2
    document.getElementById('step1-next')?.addEventListener('click', () => {
      hasStep2 ? showStep(root, 2) : (window.location.href = '/checkout');
    });

    // Step 2 actions
    document.getElementById('step2-checkout')?.addEventListener('click', () => {
      window.location.href = '/checkout';
    });
    document.getElementById('step2-continue')?.addEventListener('click', () => {
      closePopup(root);
    });
    document.getElementById('step2-skip')?.addEventListener('click', () => {
      window.location.href = '/checkout';
    });
  }

  /* -------------------------------------------------------
     Byg produktkort med nye CSS-klasser
  ------------------------------------------------------- */
  function buildCard(product, btnLabel) {
    const card = document.createElement('div');
    card.className = 'upsell-product';

    const priceStr = formatDKK(product.price);
    const compareStr = product.comparePrice > product.price
      ? `<span class="upsell-old-price">${formatDKK(product.comparePrice)}</span>`
      : '';

    card.innerHTML = `
      <div class="upsell-product-image">
        ${product.image
          ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
          : ''}
      </div>
      <div class="upsell-product-info">
        <div class="upsell-product-title">${escapeHtml(product.title)}</div>
        ${product.excerpt ? `<div class="upsell-product-description">${escapeHtml(product.excerpt)}</div>` : ''}
        <div>
          <span class="upsell-price">${priceStr}</span>${compareStr}
        </div>
        <button type="button" class="upsell-add" data-variant="${product.variantId}">
          ${escapeHtml(btnLabel)}
        </button>
      </div>
    `;

    const btn = card.querySelector('.upsell-add');
    btn.addEventListener('click', async () => {
      if (btn.disabled) return;
      btn.disabled = true;
      const original = btn.textContent.trim();
      btn.textContent = '...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(product.variantId), quantity: 1 }] })
        });
        if (res.ok) {
          btn.textContent = 'Tilføjet ✓';
          btn.classList.add('added');
          updateCartCount();
        } else {
          btn.disabled = false;
          btn.textContent = original;
        }
      } catch {
        btn.disabled = false;
        btn.textContent = original;
      }
    });

    return card;
  }

  /* -------------------------------------------------------
     Add main product to cart
  ------------------------------------------------------- */
  async function addMainToCart(productForm, btn, openDrawer) {
    const formData = new FormData(productForm);
    const mainId = formData.get('id');
    if (!mainId) { alert('Vælg venligst en variant'); return false; }

    const qty = parseInt(formData.get('quantity') || '1', 10);
    const properties = {};
    formData.forEach((val, key) => {
      const m = key.match(/^properties\[(.+)\]$/);
      if (m && val) properties[m[1]] = val;
    });

    const items = [{ id: parseInt(mainId), quantity: qty }];
    if (Object.keys(properties).length > 0) items[0].properties = properties;

    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }

    const body = { items };
    if (openDrawer) {
      const sections = [];
      if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
      if (document.querySelector('cart-icon-bubble, #cart-icon-bubble')) sections.push('cart-icon-bubble');
      if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) { showFormError(data.description || 'Kunne ikke tilføje til kurv', productForm); return false; }

      if (openDrawer) {
        // Fallback: åbn cart drawer og dispatch events
        if (data.sections) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
          } else {
            window.location.href = '/cart';
          }
        }
        // Dispatch kun når vi IKKE viser upsell popup
        try {
          if (window.PUB_SUB_EVENTS?.cartUpdate && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
          }
        } catch {}
      }
      // Når upsell popup vises: INGEN cart events – undgår konflikter med andre apps

      return true;
    } catch {
      showFormError('Der opstod en fejl. Prøv igen.', productForm);
      return false;
    } finally {
      if (btn) { btn.setAttribute('aria-disabled', 'false'); btn.classList.remove('loading'); }
    }
  }

  /* -------------------------------------------------------
     Vis/skjul steps
  ------------------------------------------------------- */
  function showStep(root, step) {
    if (root.parentElement !== document.body) document.body.appendChild(root);

    const s1 = document.getElementById('upsell-step-1');
    const s2 = document.getElementById('upsell-step-2');
    if (s1) s1.style.display = step === 1 ? 'grid' : 'none';
    if (s2) s2.style.display = step === 2 ? 'grid' : 'none';

    root.style.display = 'block';

    // Scroll lock – gem top-position på body
    const scrollY = window.scrollY;
    document.body.style.overflow   = 'hidden';
    document.body.style.position   = 'fixed';
    document.body.style.top        = `-${scrollY}px`;
    document.body.style.left       = '0';
    document.body.style.right      = '0';
  }

  function closePopup(root) {
    root.style.display = 'none';

    // Læs top-værdien NÅR vi lukker (mest pålidelig metode)
    const bodyTop = document.body.style.top;
    const scrollY = Math.abs(parseInt(bodyTop || '0'));

    document.body.style.overflow   = '';
    document.body.style.position   = '';
    document.body.style.top        = '';
    document.body.style.left       = '';
    document.body.style.right      = '';

    window.scrollTo(0, scrollY);
  }

  // Nødudgang: release scroll ved navigation/tab-skift
  window.addEventListener('pagehide', () => {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
    }
  });

  /* -------------------------------------------------------
     Opdater cart tæller
  ------------------------------------------------------- */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('.cart-count-bubble span, #cart-icon-bubble .badge').forEach(el => {
        el.textContent = cart.item_count || 0;
      });
      if (window.PUB_SUB_EVENTS?.cartUpdate && window.publish) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-popup' });
      }
    } catch {}
  }

  function showFormError(msg, productForm) {
    const wrap = document.querySelector('product-form')?.querySelector('.product-form__error-message-wrapper');
    const el = wrap?.querySelector('.product-form__error-message');
    if (wrap && el) {
      el.textContent = msg; wrap.removeAttribute('hidden');
      setTimeout(() => wrap.setAttribute('hidden', ''), 6000);
    } else { alert(msg); }
  }

  function formatDKK(cents) {
    return (cents / 100).toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' kr';
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function setText(selector, text) {
    const el = document.querySelector(selector);
    if (el && text) el.textContent = text;
  }

})();